//import services from './services.js';
import NProgress from 'nprogress';
import { lg, cloneDeep, util, isCorrectVal, isDate } from 'utils';
import $http from '$http';
import areaSelect from 'area-select';
import viewPhoto from 'src/common/js/viewPhoto';

export default {
    //mixins: [services],
    components: {
        areaSelect
    },
    props: {},
    data() {
        return {
            btnLoading: false,
            SubjectList: [], //项目类型
            isAdd: false,
            isUpdate: false,
            isReadonly: false,
            dialogVisible: false,
            agentVisible: true,
            address: {
                Provinces_Id: "",
                City_Id: "",
                Area_Id: ""
            },
            form: this.initFormData()
        }
    },
    computed: {
        AgentList() {
            return this.$store.state.AgentList;
        }
    },
    methods: {
        initFormData() {
            return cloneDeep({
                "Id": "",
                ProjectName: "",
                "AgentName": "",
                "AreaName": "",
                "BusEmployee": "",
                "ApplyTime": "",
                "ApplyCnt": 0,
                "OpenNum": 0,
                "StatusName": "",
                "ApplyPic": []
            });
        },
        show(options) {
            let opts = $.extend({}, {
                Id: "",
                isAdd: false,
                isUpdate: false,
                isReadonly: false
            }, options);

            this.isUpdate = opts.isUpdate;
            this.isAdd = opts.isAdd;
            this.isReadonly = opts.isReadonly;
            this.form.Id = opts.Id;

            this.dialogVisible = true;
            if (this.isReadonly) {
                this.req_getProjectType();
            }

        },
        addFn() {

        },
        updateFn() {

        },
        showImgView(img) {
            viewPhoto.show({
                showImgId: "", //指定id显示图片
                thumbList: [{ src: img.Url, id: "" }]
            });
        },
        req_getProjectType(callback) {
            if (this.form.Id !== "") {
                let params = { Sid: this.$store.state.sysSid, Session: this.$store.state.sysSession, Id: this.form.Id };
                //GET /api/School/SchoolApplyPicById
                //api/School/GetProjectByAgentId
                $http.get("api/School/SchoolApplyPicById", params).then(res => {
                    util.doResult(this, res, () => {
                        this.form = cloneDeep($.extend({}, this.initFormData(), util.filterAndSetData(this.initFormData(), res.data.Data)));
                        if (typeof callback == "function") {
                            callback();
                        }
                    });
                });
            }
        },
        resetForm() {
            this.form = this.initFormData();
        },
        closeCallback() {
            this.resetForm();
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Order/components/viewOpenClassDialog/vm.js